import { SET_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE } from "../actions";

export function setErrorMessage(payload) {
  let newPayload = payload;
  if (typeof payload === "object") {
    newPayload = payload.message;
  }
  return {
    type: SET_ERROR_MESSAGE,
    payload: newPayload
  };
}

export function clearErrorMessage() {
  return {
    type: CLEAR_ERROR_MESSAGE
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/errorMessage.js